import { Injectable } from "@angular/core";
import { WebApiService } from "../web-api/web-api.service";
import { CloudUser } from "./cloud-user";

@Injectable({
  providedIn: "root",
})
export class CloudUserService {

  constructor(
    private webApiService: WebApiService
  ) {}

  getCloudUser() {
    return this.webApiService.get<CloudUser>("/users/current");
  }
}
